import React from 'react'
import { AnimalProps } from 'src/@types/Animal'
import { Actions } from 'src/components/CustomTable/components/Actions'
import { causes, occurrence } from 'src/constants/deathFromDisease'
import { DeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'
import { formatDate } from 'src/utils'

interface IUseDeathsAndDiseasesTableHeader {
  setDeathsAndDiseasesItem: React.Dispatch<React.SetStateAction<DeathsAndDiseasesDto | null>>
  handleOpenModal: () => void
}

export const useDeathsAndDiseasesTableHeader = ({
  setDeathsAndDiseasesItem,
  handleOpenModal
}: IUseDeathsAndDiseasesTableHeader) => {
  const tableHeader = [
    {
      property: 'nome',
      name: 'ANIMAL',
      textAlign: 'center',
      format: (value: string | null) => (value ? value : '-')
    },
    {
      property: 'data',
      name: 'DATA',
      format: (value: string) => formatDate(value, false),
      textAlign: 'center'
    },
    {
      property: 'ocorrencia',
      name: 'OCORRÊNCIA',
      textAlign: 'center',
      format: (value: string) => occurrence[value]?.value || '-'
    },
    {
      property: 'causa',
      name: 'CAUSA',
      textAlign: 'center',
      format: (value: string) => causes[value]?.value || '-'
    },
    {
      property: 'actions',
      size: 122,
      textAlign: 'center',
      name: '',
      compoment: (value: DeathsAndDiseasesDto & AnimalProps) => (
        <Actions
          onClick={() => {
            setDeathsAndDiseasesItem(value)
            handleOpenModal()
          }}
        />
      )
    }
  ]

  return {
    tableHeader
  }
}
